import userActions from './userActions';
import accountActions from './accountActions';
import roleActions from './roleActions';
import applicationActions from './applicationActions';

// To be organized, we import all files under one location, the index.js file within the actions folder.
// We create a variable allActions and set it to an object that contains the imported actions which will be exported.
const allActions = {
    userActions,
    accountActions,
    roleActions,
    applicationActions,
}

export default allActions